// UndoRedoHotkeys.tsx
import * as React from 'react';
import { useDiagramStore } from '../ui/hooks/diagram-store.hook';
import { DiagramState } from '../store/diagram.store';
useDiagramStore;

function isEditableTarget(el: Element | null) {
  if (!el) return false;
  const tag = (el as HTMLElement).tagName?.toLowerCase();
  if (tag === 'input' || tag === 'textarea') return true;
  const he = el as HTMLElement;
  if (he.isContentEditable) return true;
  // opt-out: add data-hotkeys="off" to any element to disable
  if (he.closest?.('[data-hotkeys="off"]')) return true;
  return false;
}

export default function UndoRedoHotkeys() {
  const undo = useDiagramStore((s: DiagramState) => s.undo);
  const redo = useDiagramStore((s: DiagramState) => s.redo);

  React.useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      // Ignore when typing in a field/editor
      if (isEditableTarget(document.activeElement)) return;

      const isMac = navigator.platform.toUpperCase().includes('MAC');
      const primary = isMac ? e.metaKey : e.ctrlKey;

      // Ctrl/Cmd + Z  -> Undo
      if (primary && !e.shiftKey && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        // call fresh actions to avoid stale closures under HMR
        undo();
        return;
      }

      // Shift+Ctrl/Cmd+Z -> Redo (mac convention)
      // Ctrl+Y -> Redo (windows convention)
      if (
        (primary && e.shiftKey && e.key.toLowerCase() === 'z') ||
        (!isMac && e.ctrlKey && !e.shiftKey && e.key.toLowerCase() === 'y')
      ) {
        e.preventDefault();
        redo();
        return;
      }
    };

    window.addEventListener('keydown', onKeyDown, { capture: true });
    return () =>
      window.removeEventListener('keydown', onKeyDown, { capture: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
